import { render, staticRenderFns } from "./RelationMap.vue?vue&type=template&id=53a60f42"
import script from "./RelationMap.vue?vue&type=script&lang=ts"
export * from "./RelationMap.vue?vue&type=script&lang=ts"
import style0 from "./RelationMap.vue?vue&type=style&index=0&id=53a60f42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports